<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :disabled="disabled"
      :rules="rules"
      size="medium"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_tech_fileType') || '文档类型'"
            prop="fileType"
          >
            <dict-select
              v-model="formData.fileType"
              size="medium"
              url="/master/common/dict/biz"
              placeholder="请选择分类"
              style="width: 100%"
              filterable
              clearable
              :body="fileTypeParams"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_tech_fileName') || '文档名称'"
            v-if="disabled"
          >
            <el-input v-model="formData.fileName" type="text"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_tech_fileUrl') || '文档地址'"
            v-if="disabled"
          >
            <el-input
              v-model="formData.fileUrl"
              type="textarea"
              :autosize="{ minRows: 6 }"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="!disabled">
        <el-form-item
          :label="$l('form_label_tech_selectFile') || '选择文件'"
          required
        >
          <el-col>
            <el-upload
              drag
              multiple
              :auto-upload="false"
              :on-change="onFileChange"
              :on-remove="onFileRemove"
              action="/oss/ossUploadReturnUrlAndFileId"
              ><i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div slot="file" slot-scope="{ file }">
                <a
                  style="text-decoration: none;margin-right:50px"
                  class="el-upload-list__item-name"
                >
                  <i class="el-icon-document"></i>
                  {{ file.name }}
                </a>
                <i
                  class="el-icon-folder-opened mr-4"
                  @click="onFilePreview(file)"
                ></i>
                <i class="el-icon-close" @click="onFileDelete(file)"></i>
              </div>
            </el-upload>
          </el-col>
        </el-form-item>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    techDocCode: String,
    techCode: String,
    orderCode: { type: String, default: '' },
  },
  data() {
    return {
      fileTypeParams: { dictType: 'fileType' },
      backDialogVisible: false,
      formData: {
        techCode: this.techCode,
        orderCode: this.orderCode,
      },
      rules: {
        fileType: [
          { required: true, message: '请选择文档类型', trigger: 'change' },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.techDocCode) return
      this.$api
        .techDocDetailApi({
          techDocCode: this.techDocCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (!this.listFile || !this.listFile.length) {
        this.$message.warning(`请选择您需要上传的资料！`)
        return
      }
      this.loadingOpen()
      const listDoc = await this.uploadFiles(this.listFile)
      this.$api
        .techDocBatchUploadApi({ ...this.formData, listDoc })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('reload')
          this.close()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    uploadFiles(listFile) {
      if (!listFile || !listFile.length) {
        return Promise.resolve([])
      }
      const uploadTask = listFile.map((file) => {
        return this.$api.SYS_UPLOAD(file.raw).then((res) => ({
          fileCode: res.body.fileId,
          fileUrl: res.body.url,
          fileName: file.name,
        }))
      })
      return Promise.all(uploadTask)
    },
    onFilePreview(file) {
      const url = URL.createObjectURL(file.raw)
      window.open(url)
    },
    onFileDelete({ uid }) {
      const index = this.getIndexByFileUID(uid)
      this.listFile.splice(index, 1)
    },
    onFileChange(file, fileList) {
      this.listFile = fileList
    },
    onFileRemove(file, fileList) {
      this.listFile = fileList
    },
    getIndexByFileUID(uid) {
      const index = this.listFile.findIndex((file) => {
        return uid == file.uid
      })
      return index
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
a:hover {
  color: #409eff;
  text-decoration: none;
}

.el-upload-list__item .el-icon-folder-opened {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  opacity: 0.75;
  color: #606266;
}

.el-upload-list__item:hover {
  .el-icon-folder-opened {
    display: inline-block;
  }
}

// 重写element 样式
::v-deep {
  .el-upload-dragger {
    width: 376px;
  }
}
</style>
